import Message from '@acri-tools/react-tools/components/Message/Message';
import Search from '@acri-tools/react-tools/components/Search/Search';
import Select from '@acri-tools/react-tools/components/Select/Select';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';
import { axiosErrorHandler } from '@acri-tools/react-tools/utils/global';
import { searchParamsQuery } from '@acri-tools/react-tools/utils/query';
import request from '@acri-tools/react-tools/utils/request';
import React,{Component} from 'react';
import { connect } from 'react-redux';
import RequestForm from '../../../../components/RequestForm/RequestForm';
import UpdateRequest from '../../../../components/UpdateRequest/UpdateRequest';
import { API_URL } from '../../../../utils/config';
import { check_request, format_request_data } from '../../../../utils/requests';

interface Props{
    // REDUX
}
interface State{
    count: number
    searchParams: any
    entities?: Array<any>
    filters: any
    filterEnabled: boolean

    loading?: boolean

    message?: string
    messageType?: string

    // update
    entity?: any
    loading_entity: boolean

    updateLoading: boolean
    updateMessage: string
    updateMessageType: string
}


class SearchRequest extends Component<Props,State>{
    constructor(props:Props){
        super(props);
        this.state = {
            count: 0,
            searchParams:{
                search: '',
                offset: '0',
                limit: '10',
    
                orderby: 'id',
                orderbyDirection: 'desc',
            },
            filters:{
                "id": { active:true },
                "name": { active:true },
            },
            filterEnabled: false,
    
            // update
            loading_entity: false,

            updateLoading: false,
            updateMessage: '',
            updateMessageType: 'error',
        }
    }

    componentDidMount() {
        this.search();
    }

    render(){
        return (
            <>
                <div className="panel panel-full">
                    <h1 className="title-1">Search Requests</h1>
                    <div className="subtitle-1">Search requests using the following criteria</div>
                    <br/>


                    <Search orderby={['id','name','creation_date']} count={this.state.count}
                        filters={this.state.filters} searchParams={this.state.searchParams} search={this.search} >
                        <div className="results">
                            <div className="results-table">
                                <table className="dark">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Name</th>
                                            <th>Creation Date</th>
                                            <th>Operations</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.state.entities &&
                                            this.state.entities.map(( entity:any, idx:number )=>(
                                                <tr key={idx}>
                                                    <td>{ entity.id }</td>
                                                    <td>{ entity.name }</td>
                                                    <td>{ entity.creation_date ? new Date(entity.creation_date)?.toDateString() : null}</td>
                                                    <td>
                                                        <div className="search-operations">
                                                            <div className="search-operation custom-button inverted alt icon-only" 
                                                                onClick={()=>{ this.view(entity) }}>
                                                                <i className="fas fa-eye"/>
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        VIEW
                                                                    </div>
                                                                </div>
                                                            </div>    
                                                            <div 
                                                                className="search-operation custom-button inverted red alt icon-only" 
                                                                onClick={()=>{ 
                                                                    this.delete(entity) 
                                                                }}
                                                            >
                                                                <i className="fas fa-times"/>
                                                                <div className="tooltip">
                                                                    <div className="tooltip-content">
                                                                        DELETE
                                                                    </div>
                                                                </div>
                                                            </div>    
                                                        </div>    
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </Search>
                    
                </div>

                    {
                        this.state.loading_entity ?
                            <div className="panel panel-big">
                                <div className="centered">
                                    <Spinner white/>
                                </div>
                            </div>
                        :
                        this.state.entity &&
                        <div className="panel panel-big">
                                
                            <h1 className="title-1">Update request</h1>
                            <div className="subtitle-1">Update the selected request</div>
                            <br/>
                            <UpdateRequest
                                request={this.state.entity}
                                onUpdate={()=>{ this.search() }}
                            />
                            {/* <RequestForm
                                request={this.state.entity}
                                onChange={(updates:any)=>{
                                    this.setState({
                                        entity: {
                                            ...this.state.entity,
                                            ...updates
                                        },
                                        updateMessage: ''
                                    })
                                }}
                            />
                            <br/>
                            <br/>
                            <Message message={ this.state.updateMessage } type={ this.state.updateMessageType }/>
                            
                            {
                                this.state.updateLoading ?
                                    <div className="custom-button disabled inverted alt">
                                        <Spinner white height={12}/> UPDATING REQUEST
                                    </div>
                                :
                                    <div className="custom-button green inverted alt" onClick={this.update}>
                                        <i className="fas fa-pen"/> UPDATE REQUEST
                                    </div>
                            } */}
                        </div>
                    }
            </>
        );
    }


    search = async() =>{
        this.setState({ loading:true });
        try{
            let res = await request(`${API_URL}/api/v1/requests`,{
                method:'get',
                params:{
                    ...searchParamsQuery(this.state.searchParams, this.state.filters),
                    count: true
                },
            })
            this.setState({ entities: res.data.value, count: res.data.count });
        }
        catch(e:any){
            axiosErrorHandler( e, { 
                functionName: 'search', 
                requestName: 'search_requests',
            })
            this.setState({
                loading:false,
                message: e.response && e.response.data && e.response.data.error  ? e.response.data.error : 'An error has occured.',
                messageType: 'error'
            })
        }
        finally{
            this.setState({ loading:false })
        }
    }

    delete = (entity: any) =>{
        if(window.confirm(`Are you sure you want to delete requests '${entity.name}' ?`)){
            request(`${API_URL}/api/v1/requests/${entity.id}`,{
                method:'delete',
            })
            .then((res:any)=>{
                this.search();
            })
            .catch(e=>{
                axiosErrorHandler( e, { 
                    functionName: 'delete', 
                    requestName: 'delete_requests',
                })
            })
        }
    }

    view = async(e:any) =>{
        this.setState({ loading_entity:true })
        try{
            let res = await request(`${API_URL}/api/v1/requests/${e.id}`,{
                method:'get'
            })

            let entity = res.data;
            [ 'product_type', 'filters', 'additional_requirements', 'target_products', 'period', 'aoi' ].forEach((attribute: string)=>{
                if(!(attribute in entity && entity[attribute] !== null)){
                    entity[attribute] = [];
                }
            });

            // console.log("entity", entity)

            this.setState({ entity, updateMessage:'' });
        }
        catch(e:any){

            axiosErrorHandler( e, { 
                functionName: 'view', 
                requestName: 'view_request',
            })
        }
        finally{
            this.setState({ loading_entity:false })
        }
    }
};


export default SearchRequest;
